import { Component, inject, OnInit, Signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LoadingInfo, LoadingService, LoadingSpinnerComponent } from '@lx/shared/ui/loading-spinner';

@Component({
  standalone: true,
  imports: [RouterOutlet, ProgressSpinnerModule, LoadingSpinnerComponent],
  selector: 'lx-price-lists-portal',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss', './print-app.component.scss'],
})
export class AppComponent implements OnInit {
  protected loadingInfo: Signal<LoadingInfo>;

  private readonly loadingService = inject(LoadingService);

  ngOnInit(): void {
    this.loadingInfo = this.loadingService.loading;
  }
}
